import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import { useState } from "react";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const NhbAddress = ({ nhbAddressList }) => {

   const theme = useTheme();
   const [activeStep, setActiveStep] = useState(0);

  const maxSteps = validate(nhbAddressList) ?  nhbAddressList.length : 0;

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

   const nhbAddressComponent = () => {
      const nhbAddressDetails = validate(nhbAddressList) ? nhbAddressList[activeStep] : undefined;
      return (
         <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="ID"
                variant="standard"
                placeholder="Enter ID"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.id : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Application ID"
                variant="standard"
                placeholder="Enter Internal Application ID"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.internalApplicationId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Technical ID"
                variant="standard"
                placeholder="Enter Internal Technical ID"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.internalTechnicalId : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="NHB Type Code"
                variant="standard"
                placeholder="Enter NHB Type Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.nhbTypeCode : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="NHB Type"
                variant="standard"
                placeholder="Enter NHB Type"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.nhbType : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Metro Type Code"
                variant="standard"
                placeholder="Enter Metro Type Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.metroTypeCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Metro Type"
                variant="standard"
                placeholder="Enter Metro Type"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.metroType : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Completion Stage Code"
                variant="standard"
                placeholder="Enter Completion Stage Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.completionStageCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Completion Stage Description"
                variant="standard"
                placeholder="Enter Completion Stage Description"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.completionStageDesc : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="State Code"
                variant="standard"
                placeholder="Enter State Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.stateCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="State"
                variant="standard"
                placeholder="Enter State"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.state : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="District Code"
                variant="standard"
                placeholder="Enter District Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.districtCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="District"
                variant="standard"
                placeholder="Enter District"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.district : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Location Code"
                variant="standard"
                placeholder="Enter Location Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.locationCode : ""}
              />
              </Grid>
              
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Location"
                variant="standard"
                placeholder="Enter Location"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.location : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Sub Location Code"
                variant="standard"
                placeholder="Enter Sub Location Code"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.subLocationCode : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Sub Location"
                variant="standard"
                placeholder="Enter Sub Location"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.subLocation : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Planning Commission Name"
                variant="standard"
                placeholder="Enter Planning Commission Name"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.planningCommissionName : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created By"
                variant="standard"
                placeholder="Enter Created By"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.createdBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified By"
                variant="standard"
                placeholder="Enter Modified By"
                disabled={true}
                value={nhbAddressDetails !== undefined ? nhbAddressDetails.modifiedBy : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Created Date"
                variant="standard"
                placeholder="Enter Created Date"
                disabled={true}
                value={nhbAddressDetails !== undefined ? convertDateWithValidation(nhbAddressDetails.createdDate) : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Modified Date"
                variant="standard"
                placeholder="Enter Modified Date"
                disabled={true}
                value={nhbAddressDetails !== undefined ? convertDateWithValidation(nhbAddressDetails.modifiedDate) : ""}
              />
              </Grid>
              </Grid>
      );
   }

    return(
         <AccordianContainer
          id="accord"
          title="NHB Address"
          initialOpen={false}
        >
        <Box sx={{ marginTop: "-1%" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                         <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                        { maxSteps > 1 && <MobileStepper
                          variant="text"
                          steps={maxSteps}
                          position="static"
                          activeStep={activeStep}
                          sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                            nextButton={
                            <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                                Next
                            {theme.direction === 'rtl' ? (
                            <KeyboardArrowLeft />
                            ) : ( <KeyboardArrowRight /> )}
                           </Button>
                         }
                        backButton={
                        <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                        {theme.direction === 'rtl' ? (
                            <KeyboardArrowRight />
                        ) : (
                            <KeyboardArrowLeft />
                        )}
                            Back
                        </Button>
                    }
                    /> }
                    </Box>
                    </Grid>
                    { nhbAddressComponent() }
        </Box>
        </AccordianContainer>
);
 
}

export default NhbAddress;